import React from 'react';
import { LoggedInNav } from '../components/LoggedInNav';
import { PieChartIcon, BarChartIcon, ClockIcon, UsersIcon, CalendarIcon, RepeatIcon, UserPlusIcon, CheckCircleIcon, EyeIcon, EyeOffIcon, ChevronRightIcon, BellIcon, AlertCircleIcon, CheckIcon, SlackIcon, MailIcon, ExternalLinkIcon, BarChart3Icon, LineChartIcon, PercentIcon, TimerIcon, SearchIcon, BuildingIcon, ServerIcon, DatabaseIcon, LinkIcon } from 'lucide-react';
export function Dashboard() {
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-1474">
      <LoggedInNav data-id="element-1475" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1476">
        <div className="mb-8" data-id="element-1477">
          <h1 className="text-2xl font-bold mb-2" data-id="element-1478">Welcome back, John</h1>
          <p className="text-[#F5F7FA] text-opacity-70" data-id="element-1479">
            You have 3 meetings scheduled for today
          </p>
        </div>
        {/* Top Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1480">
          <div className="bg-[#1A2331] p-5 rounded-lg shadow-lg" data-id="element-1481">
            <div className="flex items-start justify-between mb-3" data-id="element-1482">
              <div data-id="element-1483">
                <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1484">
                  Average Meetings Per Week
                </p>
                <div className="flex items-baseline" data-id="element-1485">
                  <h3 className="text-3xl font-bold mr-2" data-id="element-1486">8.5</h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-[#C8F169] bg-opacity-20 text-[#C8F169]" data-id="element-1487">
                    +12%
                  </span>
                </div>
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#F5F7FA] bg-opacity-10 flex items-center justify-center" data-id="element-1488">
                <CalendarIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1489" />
              </div>
            </div>
          </div>
          <div className="bg-[#1A2331] p-5 rounded-lg shadow-lg" data-id="element-1490">
            <div className="flex items-start justify-between mb-3" data-id="element-1491">
              <div data-id="element-1492">
                <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1493">
                  Preparation Time Saved
                </p>
                <div className="flex items-baseline" data-id="element-1494">
                  <h3 className="text-3xl font-bold mr-2" data-id="element-1495">12.5</h3>
                  <span className="text-sm font-medium" data-id="element-1496">hours</span>
                </div>
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#F5F7FA] bg-opacity-10 flex items-center justify-center" data-id="element-1497">
                <ClockIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1498" />
              </div>
            </div>
          </div>
          <div className="bg-[#1A2331] p-5 rounded-lg shadow-lg" data-id="element-1499">
            <div className="flex items-start justify-between mb-3" data-id="element-1500">
              <div data-id="element-1501">
                <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1502">
                  Meeting Coverage
                </p>
                <div className="flex items-baseline" data-id="element-1503">
                  <h3 className="text-3xl font-bold mr-2" data-id="element-1504">92%</h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-[#C8F169] bg-opacity-20 text-[#C8F169]" data-id="element-1505">
                    +5%
                  </span>
                </div>
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#F5F7FA] bg-opacity-10 flex items-center justify-center" data-id="element-1506">
                <CheckCircleIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1507" />
              </div>
            </div>
            <div className="text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1508">
              briefs generated / eligible meetings
            </div>
          </div>
          <div className="bg-[#1A2331] p-5 rounded-lg shadow-lg" data-id="element-1509">
            <div className="flex items-start justify-between mb-3" data-id="element-1510">
              <div data-id="element-1511">
                <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1512">
                  Weekly Active Workspaces
                </p>
                <div className="flex items-baseline" data-id="element-1513">
                  <h3 className="text-3xl font-bold mr-2" data-id="element-1514">42</h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-[#C8F169] bg-opacity-20 text-[#C8F169]" data-id="element-1515">
                    +8
                  </span>
                </div>
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#F5F7FA] bg-opacity-10 flex items-center justify-center" data-id="element-1516">
                <BuildingIcon className="h-5 w-5 text-[#C8F169]" data-id="element-1517" />
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1518">
          {/* Main Analytics Section */}
          <div className="lg:col-span-2" data-id="element-1519">
            <div className="bg-[#1A2331] rounded-xl p-6 shadow-lg mb-6" data-id="element-1520">
              <div className="flex justify-between items-center mb-6" data-id="element-1521">
                <h2 className="text-lg font-semibold" data-id="element-1522">Meeting Analytics</h2>
                <div className="flex space-x-2" data-id="element-1523">
                  <button className="bg-[#C8F169] bg-opacity-20 text-[#C8F169] px-3 py-1 rounded-lg text-sm" data-id="element-1524">
                    This Week
                  </button>
                  <button className="bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 text-[#F5F7FA] px-3 py-1 rounded-lg text-sm" data-id="element-1525">
                    This Month
                  </button>
                  <button className="bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 text-[#F5F7FA] px-3 py-1 rounded-lg text-sm" data-id="element-1526">
                    All Time
                  </button>
                </div>
              </div>
              {/* Briefs Delivered by Channel */}
              <div className="mb-8" data-id="element-1527">
                <h3 className="text-sm font-medium mb-4" data-id="element-1528">
                  Briefs Delivered by Channel
                </h3>
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1529">
                  <div className="flex space-x-1 h-48 items-end mb-3" data-id="element-1530">
                    <div className="flex-1 flex flex-col items-center" data-id="element-1531">
                      <div className="w-full bg-[#3B82F6] rounded-t-sm" style={{
                      height: '65%'
                    }} data-id="element-1532"></div>
                      <div className="mt-2 text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1533">
                        Slack
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col items-center" data-id="element-1534">
                      <div className="w-full bg-[#C8F169] rounded-t-sm" style={{
                      height: '40%'
                    }} data-id="element-1535"></div>
                      <div className="mt-2 text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1536">
                        Email
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col items-center" data-id="element-1537">
                      <div className="w-full bg-[#EC4899] rounded-t-sm" style={{
                      height: '25%'
                    }} data-id="element-1538"></div>
                      <div className="mt-2 text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1539">
                        Prepz.io
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col items-center" data-id="element-1540">
                      <div className="w-full bg-[#F59E0B] rounded-t-sm" style={{
                      height: '15%'
                    }} data-id="element-1541"></div>
                      <div className="mt-2 text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1542">
                        Salesforce
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col items-center" data-id="element-1543">
                      <div className="w-full bg-[#10B981] rounded-t-sm" style={{
                      height: '10%'
                    }} data-id="element-1544"></div>
                      <div className="mt-2 text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1545">
                        Hubspot
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1546">
                    <div data-id="element-1547">Slack: 65%</div>
                    <div data-id="element-1548">Email: 40%</div>
                    <div data-id="element-1549">Prepz.io: 25%</div>
                    <div data-id="element-1550">Salesforce: 15%</div>
                    <div data-id="element-1551">Hubspot: 10%</div>
                  </div>
                </div>
              </div>
              {/* Brief Open Rate by Channel */}
              <div className="mb-8" data-id="element-1552">
                <h3 className="text-sm font-medium mb-4" data-id="element-1553">
                  Brief Open Rate by Channel
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1554">
                  {/* Slack */}
                  <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1555">
                    <div className="flex items-center justify-between mb-3" data-id="element-1556">
                      <div className="flex items-center" data-id="element-1557">
                        <SlackIcon className="h-5 w-5 text-[#3B82F6] mr-2" data-id="element-1558" />
                        <h4 className="font-medium" data-id="element-1559">Slack</h4>
                      </div>
                      <span className="text-xl font-bold" data-id="element-1560">86%</span>
                    </div>
                    <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2" data-id="element-1561">
                      <div className="bg-[#3B82F6] h-2 rounded-full" style={{
                      width: '86%'
                    }} data-id="element-1562"></div>
                    </div>
                  </div>
                  {/* Calendar */}
                  <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1563">
                    <div className="flex items-center justify-between mb-3" data-id="element-1564">
                      <div className="flex items-center" data-id="element-1565">
                        <CalendarIcon className="h-5 w-5 text-[#C8F169] mr-2" data-id="element-1566" />
                        <h4 className="font-medium" data-id="element-1567">Calendar</h4>
                      </div>
                      <span className="text-xl font-bold" data-id="element-1568">72%</span>
                    </div>
                    <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2" data-id="element-1569">
                      <div className="bg-[#C8F169] h-2 rounded-full" style={{
                      width: '72%'
                    }} data-id="element-1570"></div>
                    </div>
                  </div>
                  {/* Email */}
                  <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1571">
                    <div className="flex items-center justify-between mb-3" data-id="element-1572">
                      <div className="flex items-center" data-id="element-1573">
                        <MailIcon className="h-5 w-5 text-[#EC4899] mr-2" data-id="element-1574" />
                        <h4 className="font-medium" data-id="element-1575">Email</h4>
                      </div>
                      <span className="text-xl font-bold" data-id="element-1576">58%</span>
                    </div>
                    <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2" data-id="element-1577">
                      <div className="bg-[#EC4899] h-2 rounded-full" style={{
                      width: '58%'
                    }} data-id="element-1578"></div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Pre-brief Timeliness */}
              <div className="mb-8" data-id="element-1579">
                <h3 className="text-sm font-medium mb-4" data-id="element-1580">
                  Pre-brief Timeliness (% delivered ≥15 min before start)
                </h3>
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1581">
                  <div className="flex items-center justify-between mb-4" data-id="element-1582">
                    <div className="flex items-center" data-id="element-1583">
                      <TimerIcon className="h-5 w-5 text-[#C8F169] mr-2" data-id="element-1584" />
                      <span data-id="element-1585">On-time Delivery Rate</span>
                    </div>
                    <span className="text-xl font-bold" data-id="element-1586">94%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-3 mb-3" data-id="element-1587">
                    <div className="bg-[#C8F169] h-3 rounded-full" style={{
                    width: '94%'
                  }} data-id="element-1588"></div>
                  </div>
                  <div className="flex justify-between text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1589">
                    <div data-id="element-1590">≥30 min: 82%</div>
                    <div data-id="element-1591">15-30 min: 12%</div>
                    <div data-id="element-1592">5-15 min: 4%</div>
                    <div data-id="element-1593">&lt;5 min: 2%</div>
                  </div>
                </div>
              </div>
              {/* Refine Actions per Brief */}
              <div className="mb-8" data-id="element-1594">
                <h3 className="text-sm font-medium mb-4" data-id="element-1595">
                  Refine Actions per Brief (Interactive Usage)
                </h3>
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1596">
                  <div className="grid grid-cols-2 gap-6" data-id="element-1597">
                    <div data-id="element-1598">
                      <div className="flex items-center justify-between mb-2" data-id="element-1599">
                        <span className="text-sm" data-id="element-1600">Average Actions</span>
                        <span className="font-bold" data-id="element-1601">3.2</span>
                      </div>
                      <div className="space-y-2" data-id="element-1602">
                        <div data-id="element-1603">
                          <div className="flex justify-between text-xs mb-1" data-id="element-1604">
                            <span data-id="element-1605">Follow-up Questions</span>
                            <span data-id="element-1606">1.8</span>
                          </div>
                          <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1607">
                            <div className="bg-[#3B82F6] h-1.5 rounded-full" style={{
                            width: '60%'
                          }} data-id="element-1608"></div>
                          </div>
                        </div>
                        <div data-id="element-1609">
                          <div className="flex justify-between text-xs mb-1" data-id="element-1610">
                            <span data-id="element-1611">Research Requests</span>
                            <span data-id="element-1612">0.7</span>
                          </div>
                          <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1613">
                            <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                            width: '23%'
                          }} data-id="element-1614"></div>
                          </div>
                        </div>
                        <div data-id="element-1615">
                          <div className="flex justify-between text-xs mb-1" data-id="element-1616">
                            <span data-id="element-1617">Talking Points</span>
                            <span data-id="element-1618">0.5</span>
                          </div>
                          <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1619">
                            <div className="bg-[#EC4899] h-1.5 rounded-full" style={{
                            width: '17%'
                          }} data-id="element-1620"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-1621">
                      <div className="flex items-center justify-between mb-2" data-id="element-1622">
                        <span className="text-sm" data-id="element-1623">Interaction Depth</span>
                        <span className="font-bold" data-id="element-1624">Medium</span>
                      </div>
                      <div className="relative pt-5" data-id="element-1625">
                        <div className="flex justify-between text-xs mb-1" data-id="element-1626">
                          <span data-id="element-1627">Low</span>
                          <span data-id="element-1628">Medium</span>
                          <span data-id="element-1629">High</span>
                        </div>
                        <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2" data-id="element-1630">
                          <div className="bg-[#C8F169] h-2 rounded-full" style={{
                          width: '65%'
                        }} data-id="element-1631"></div>
                        </div>
                        <div className="absolute top-0 left-[65%] transform -translate-x-1/2" data-id="element-1632">
                          <div className="w-3 h-3 bg-[#C8F169] rounded-full" data-id="element-1633"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Accuracy & Enrichment */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1634">
                {/* Accuracy Complaints */}
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1635">
                  <div className="flex items-center justify-between mb-4" data-id="element-1636">
                    <h3 className="font-medium text-sm" data-id="element-1637">
                      Accuracy Complaints /100 briefs
                    </h3>
                    <AlertCircleIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-1638" />
                  </div>
                  <div className="flex items-center justify-between mb-3" data-id="element-1639">
                    <span className="text-sm" data-id="element-1640">Human-flagged issues</span>
                    <span className="text-2xl font-bold text-[#C8F169]" data-id="element-1641">
                      1.3
                    </span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2 mb-3" data-id="element-1642">
                    <div className="bg-[#C8F169] h-2 rounded-full" style={{
                    width: '13%'
                  }} data-id="element-1643"></div>
                  </div>
                  <div className="text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1644">
                    <div className="flex justify-between mb-1" data-id="element-1645">
                      <span data-id="element-1646">Industry: 2.1</span>
                      <span data-id="element-1647">Your score: 1.3</span>
                    </div>
                    <div className="flex items-center text-[#C8F169]" data-id="element-1648">
                      <CheckIcon className="h-3 w-3 mr-1" data-id="element-1649" />
                      <span data-id="element-1650">38% better than average</span>
                    </div>
                  </div>
                </div>
                {/* Enrichment Hit Rate */}
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1651">
                  <div className="flex items-center justify-between mb-4" data-id="element-1652">
                    <h3 className="font-medium text-sm" data-id="element-1653">Enrichment Hit Rate</h3>
                    <DatabaseIcon className="h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-1654" />
                  </div>
                  <div className="flex items-center justify-between mb-3" data-id="element-1655">
                    <span className="text-sm" data-id="element-1656">Avg match confidence</span>
                    <span className="text-2xl font-bold" data-id="element-1657">87%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2 mb-3" data-id="element-1658">
                    <div className="bg-[#3B82F6] h-2 rounded-full" style={{
                    width: '87%'
                  }} data-id="element-1659"></div>
                  </div>
                  <div className="text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1660">
                    <div className="flex justify-between" data-id="element-1661">
                      <span data-id="element-1662">LinkedIn: 92%</span>
                      <span data-id="element-1663">Company: 89%</span>
                      <span data-id="element-1664">Social: 76%</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Connected Systems */}
              <div className="mb-6" data-id="element-1665">
                <h3 className="text-sm font-medium mb-4" data-id="element-1666">Integration Status</h3>
                <div className="bg-[#1E2A38] p-5 rounded-lg" data-id="element-1667">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1668">
                    {/* % Users with Slack */}
                    <div data-id="element-1669">
                      <div className="flex items-center justify-between mb-3" data-id="element-1670">
                        <div className="flex items-center" data-id="element-1671">
                          <SlackIcon className="h-5 w-5 text-[#3B82F6] mr-2" data-id="element-1672" />
                          <span data-id="element-1673">Slack Connected</span>
                        </div>
                        <span className="text-xl font-bold" data-id="element-1674">78%</span>
                      </div>
                      <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2 mb-3" data-id="element-1675">
                        <div className="bg-[#3B82F6] h-2 rounded-full" style={{
                        width: '78%'
                      }} data-id="element-1676"></div>
                      </div>
                      <div className="flex justify-between text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1677">
                        <span data-id="element-1678">Team members: 42/54</span>
                        <button className="text-[#3B82F6]" data-id="element-1679">Invite</button>
                      </div>
                    </div>
                    {/* % Users with CRM */}
                    <div data-id="element-1680">
                      <div className="flex items-center justify-between mb-3" data-id="element-1681">
                        <div className="flex items-center" data-id="element-1682">
                          <LinkIcon className="h-5 w-5 text-[#C8F169] mr-2" data-id="element-1683" />
                          <span data-id="element-1684">CRM Connected</span>
                        </div>
                        <span className="text-xl font-bold" data-id="element-1685">65%</span>
                      </div>
                      <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-2 mb-3" data-id="element-1686">
                        <div className="bg-[#C8F169] h-2 rounded-full" style={{
                        width: '65%'
                      }} data-id="element-1687"></div>
                      </div>
                      <div className="flex justify-between text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1688">
                        <span data-id="element-1689">Salesforce: 28 | Hubspot: 7</span>
                        <button className="text-[#C8F169]" data-id="element-1690">Connect</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-4 border-t border-[#F5F7FA] border-opacity-10" data-id="element-1691">
                <div className="flex justify-between items-center" data-id="element-1692">
                  <h3 className="font-medium" data-id="element-1693">Upcoming Meetings (3)</h3>
                  <button className="text-sm text-[#C8F169] flex items-center" data-id="element-1694">
                    View all <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-1695" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column */}
          <div data-id="element-1696">
            <div className="bg-[#1A2331] rounded-xl p-6 shadow-lg mb-6" data-id="element-1697">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1698">Your Prep Score</h2>
              <div className="flex items-center justify-center mb-4" data-id="element-1699">
                <div className="relative w-32 h-32" data-id="element-1700">
                  <svg className="w-full h-full" viewBox="0 0 36 36" data-id="element-1701">
                    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#F5F7FA" strokeOpacity="0.1" strokeWidth="3" strokeLinecap="round" data-id="element-1702" />
                    <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#C8F169" strokeWidth="3" strokeDasharray="85, 100" strokeLinecap="round" data-id="element-1703" />
                  </svg>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center" data-id="element-1704">
                    <div className="text-3xl font-bold" data-id="element-1705">85%</div>
                    <div className="text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1706">
                      Prepared
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-1707">
                <div data-id="element-1708">
                  <div className="flex justify-between text-sm mb-1" data-id="element-1709">
                    <span data-id="element-1710">Attendee Research</span>
                    <span data-id="element-1711">100%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1712">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '100%'
                  }} data-id="element-1713"></div>
                  </div>
                </div>
                <div data-id="element-1714">
                  <div className="flex justify-between text-sm mb-1" data-id="element-1715">
                    <span data-id="element-1716">Company Insights</span>
                    <span data-id="element-1717">90%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1718">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '90%'
                  }} data-id="element-1719"></div>
                  </div>
                </div>
                <div data-id="element-1720">
                  <div className="flex justify-between text-sm mb-1" data-id="element-1721">
                    <span data-id="element-1722">Meeting Notes</span>
                    <span data-id="element-1723">65%</span>
                  </div>
                  <div className="w-full bg-[#F5F7FA] bg-opacity-10 rounded-full h-1.5" data-id="element-1724">
                    <div className="bg-[#C8F169] h-1.5 rounded-full" style={{
                    width: '65%'
                  }} data-id="element-1725"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#1A2331] rounded-xl p-6 shadow-lg mb-6" data-id="element-1726">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1727">
                Weekly Active Workspaces
              </h2>
              <div className="flex items-center justify-center mb-4" data-id="element-1728">
                <div className="relative w-full h-48" data-id="element-1729">
                  {/* Line chart for WAW */}
                  <svg className="w-full h-full" viewBox="0 0 300 150" preserveAspectRatio="none" data-id="element-1730">
                    {/* Grid lines */}
                    <line x1="0" y1="0" x2="300" y2="0" stroke="#F5F7FA" strokeOpacity="0.1" data-id="element-1731" />
                    <line x1="0" y1="50" x2="300" y2="50" stroke="#F5F7FA" strokeOpacity="0.1" data-id="element-1732" />
                    <line x1="0" y1="100" x2="300" y2="100" stroke="#F5F7FA" strokeOpacity="0.1" data-id="element-1733" />
                    <line x1="0" y1="150" x2="300" y2="150" stroke="#F5F7FA" strokeOpacity="0.1" data-id="element-1734" />
                    {/* Line chart */}
                    <path d="M0,120 L50,110 L100,100 L150,90 L200,70 L250,60 L300,50" fill="none" stroke="#C8F169" strokeWidth="3" data-id="element-1735" />
                    <path d="M0,120 L50,110 L100,100 L150,90 L200,70 L250,60 L300,50 L300,150 L0,150 Z" fill="#C8F169" fillOpacity="0.1" data-id="element-1736" />
                    {/* Data points */}
                    <circle cx="0" cy="120" r="4" fill="#C8F169" data-id="element-1737" />
                    <circle cx="50" cy="110" r="4" fill="#C8F169" data-id="element-1738" />
                    <circle cx="100" cy="100" r="4" fill="#C8F169" data-id="element-1739" />
                    <circle cx="150" cy="90" r="4" fill="#C8F169" data-id="element-1740" />
                    <circle cx="200" cy="70" r="4" fill="#C8F169" data-id="element-1741" />
                    <circle cx="250" cy="60" r="4" fill="#C8F169" data-id="element-1742" />
                    <circle cx="300" cy="50" r="4" fill="#C8F169" data-id="element-1743" />
                  </svg>
                </div>
              </div>
              <div className="flex justify-between text-xs text-[#F5F7FA] text-opacity-70" data-id="element-1744">
                <span data-id="element-1745">6 weeks ago</span>
                <span data-id="element-1746">4 weeks ago</span>
                <span data-id="element-1747">2 weeks ago</span>
                <span data-id="element-1748">Current</span>
              </div>
              <div className="mt-4 text-center" data-id="element-1749">
                <div className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-1750">
                  Growth Rate
                </div>
                <div className="text-xl font-bold text-[#C8F169]" data-id="element-1751">+22% MoM</div>
              </div>
            </div>
            <div className="bg-[#1A2331] rounded-xl p-6 shadow-lg" data-id="element-1752">
              <h2 className="text-lg font-semibold mb-4" data-id="element-1753">Quick Actions</h2>
              <div className="space-y-3" data-id="element-1754">
                <button className="w-full bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 transition-colors p-3 rounded-lg text-left" data-id="element-1755">
                  Generate meeting agenda
                </button>
                <button className="w-full bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 transition-colors p-3 rounded-lg text-left" data-id="element-1756">
                  Research competitor
                </button>
                <button className="w-full bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 transition-colors p-3 rounded-lg text-left" data-id="element-1757">
                  Summarize previous notes
                </button>
                <button className="w-full bg-[#F5F7FA] bg-opacity-5 hover:bg-opacity-10 transition-colors p-3 rounded-lg text-left" data-id="element-1758">
                  Prepare talking points
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}